import React, { ReactElement } from 'react';
import style from './style.module.scss';
import { PreviewSection } from '../../components/sections/preview';
import { CinemaSection } from '../../components/sections/cinema';
import { BenefitsSection } from '../../components/sections/benefits';
import { WatchFirstSection } from '../../components/sections/watchFirst';
import { ReadySection } from '../../components/sections/ready';
import { StepsSection } from '../../components/sections/steps';
import { Footer } from '../../components/footer';

export const HomePage = (): ReactElement => (
  <main className={style.page}>
    <PreviewSection />
    <CinemaSection />
    <BenefitsSection />
    <WatchFirstSection />
    <ReadySection />
    <StepsSection />
    <Footer />
  </main>
);
